import React from 'react';
import { Row, Col, FormGroup, Label, InputGroup } from 'reactstrap';
import { useIntl, FormattedMessage } from 'react-intl';
import { CustomDashboardInput } from '../../../containers';
import { USER_ACCOUNT_TYPES } from '../../../constants/userDefs';
import { PlaceAndZipInput } from '../../../components/PlaceAndZipInput';

export const UserCreateBusinessForm = ({
  inputHandler,
  places,
  loadingPlaces,
  countries,
  loadingCountries,
  sector,
  setSector,
  submitted,
  OIB,
  setOIB,
  mbo,
  setMbo,
  businessName,
  setBusinessName,
  VATpayer,
  setVATpayer,
  address,
  setAddress,
  city,
  setCity,
  zip,
  setZip,
  country,
  setCountry,
  businessFirstName,
  setBusinessFirstName,
  businessLastName,
  setBusinessLastName,
  businessTelephone,
  setBusinessTelephone,
  webAddress,
  setWebAddress,
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Row>
        <Col>
          <h3>
            <FormattedMessage id="adminCreateUserPage.basicInfo" /> *
          </h3>
        </Col>
      </Row>
      <FormGroup row className="mt-3">
        <Col xs="12" sm="6">
          <Label for="sector">
            <FormattedMessage id="inputs.sector" />
          </Label>
          <InputGroup>
            <div className="hok-select">
              <CustomDashboardInput
                className="text-uppercase"
                type="select"
                id="sector"
                fieldState={sector}
                onChange={event => inputHandler(setSector, event.target.value)}>
                <option disabled value=""></option>
                {USER_ACCOUNT_TYPES.map(type => (
                  <option key={type.name} value={type.name}>
                    {formatMessage({ id: `adminCreateUserPage.filter.${type.name}` })}
                  </option>
                ))}
              </CustomDashboardInput>
            </div>
          </InputGroup>
        </Col>
        <Col xs="12" sm="6">
          <Label for="OIB">
            <FormattedMessage id="inputs.OIB" />
          </Label>
          <InputGroup>
            <CustomDashboardInput
              id="OIB"
              fieldState={OIB}
              onChange={event => inputHandler(setOIB, event.target.value)}
            />
          </InputGroup>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Col xs="12" sm="6">
          <Label for="mbo">
            <FormattedMessage id="inputs.MBO" />
          </Label>
          <InputGroup>
            <CustomDashboardInput
              id="mbo"
              fieldState={mbo}
              onChange={event => inputHandler(setMbo, event.target.value)}
            />
          </InputGroup>
        </Col>
        <Col xs="12" sm="6">
          <Label for="name">
            <FormattedMessage id="inputs.name" />
          </Label>
          <InputGroup>
            <CustomDashboardInput
              id="name"
              fieldState={businessName}
              onChange={event => inputHandler(setBusinessName, event.target.value)}
            />
          </InputGroup>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Col xs="12" sm="6">
          <Label for="VATpayer">
            <FormattedMessage id="inputs.VATpayer" />
          </Label>
          <InputGroup>
            <div className="hok-select">
              <CustomDashboardInput
                id="VATpayer"
                type="select"
                value={VATpayer.value}
                fieldState={VATpayer}
                formSubmitted={submitted}
                onChange={event => {
                  const VATpayer = event.target.value === 'true';
                  inputHandler(setVATpayer, VATpayer);
                }}>
                <option value={true}>{formatMessage({ id: 'yes' }).toUpperCase()}</option>
                <option value={false}>{formatMessage({ id: 'no' }).toUpperCase()}</option>
              </CustomDashboardInput>
            </div>
          </InputGroup>
        </Col>
        <Col xs="12" sm="6">
          <Label for="address">
            <FormattedMessage id="inputs.address" />
          </Label>
          <InputGroup>
            <CustomDashboardInput
              id="address"
              fieldState={address}
              onChange={event => inputHandler(setAddress, event.target.value)}
            />
          </InputGroup>
        </Col>
      </FormGroup>
      <FormGroup row>
        <PlaceAndZipInput
          places={places}
          loadingPlaces={loadingPlaces}
          zip={zip}
          setZip={setZip}
          city={city}
          setCity={setCity}
        />
      </FormGroup>
      <FormGroup row className="mb-5">
        <Col sm="6">
          <Label for="country">
            <FormattedMessage id="inputs.country" />
          </Label>
          <InputGroup>
            <div className="hok-select">
              <CustomDashboardInput
                id="country"
                type="select"
                value={country.value}
                fieldState={country}
                formSubmitted={submitted}
                disabled
                // onChange={event => inputHandler(setCountry, event.target.value)}
              >
                <option disabled value=""></option>
                {(loadingCountries || !countries) && <option disabled>{country.value}</option>}
                {loadingCountries ? (
                  <option disabled value="">
                    {formatMessage({ id: 'loading' })}
                  </option>
                ) : (
                  countries.map(country => (
                    <option key={country.codeLegacy} value={country.codeLegacy}>
                      {country.nameCro}
                    </option>
                  ))
                )}
              </CustomDashboardInput>
            </div>
          </InputGroup>
        </Col>
        <Col sm="6">
          <Label for="webAddress">
            <FormattedMessage id="inputs.webAddress" />
          </Label>
          <InputGroup>
            <CustomDashboardInput
              id="webAddress"
              name="web address"
              fieldState={webAddress}
              onChange={event => inputHandler(setWebAddress, event.target.value)}
            />
          </InputGroup>
        </Col>
      </FormGroup>

      <Row>
        <Col>
          <h3>
            <FormattedMessage id="adminCreateUserPage.contactInfo" />
          </h3>
        </Col>
      </Row>
      <FormGroup row className="mt-3">
        <Col xs="12" sm="6">
          <Label for="firstName">
            <FormattedMessage id="inputs.firstName" />
          </Label>
          <InputGroup>
            <CustomDashboardInput
              id="firstName"
              fieldState={businessFirstName}
              onChange={event => inputHandler(setBusinessFirstName, event.target.value)}
            />
          </InputGroup>
        </Col>
        <Col xs="12" sm="6">
          <Label for="lastName">
            <FormattedMessage id="inputs.lastName" />
          </Label>
          <InputGroup>
            <CustomDashboardInput
              id="lastName"
              fieldState={businessLastName}
              onChange={event => inputHandler(setBusinessLastName, event.target.value)}
            />
          </InputGroup>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Col sm="6">
          <Label for="businessTelephone">
            <FormattedMessage id="inputs.businessTelephone" />
          </Label>
          <InputGroup>
            <CustomDashboardInput
              id="businessTelephone"
              name="business telephone"
              fieldState={businessTelephone}
              onChange={event => inputHandler(setBusinessTelephone, event.target.value)}
            />
          </InputGroup>
        </Col>
      </FormGroup>
    </>
  );
};
